import Afiche from "./Afiche"

const Week = (props: any) : JSX.Element => {
  return <Afiche />
}

export default Week